import { useParams } from 'react-router-dom';
import './FarmDetails.css';

export default function FarmDetails() {
  const { id } = useParams();

  return (
    <div className="farm-details-page">
      <div className="farm-details-container">
        <h1>Ферма #{id}</h1>
        <div className="farm-details-content">
          <p>Здесь будет информация о ферме</p>
        </div>
      </div>
    </div>
  );
}
